// Fix: the product image gallery (.primgSlider, a Slick carousel) does not
// upgrade a slide's image from its low-res lazyload placeholder when the
// slide becomes active via thumbnail click or swipe. lazySizes' own
// unveil() call doesn't re-trigger a load for these slides in this theme,
// so this manually builds the real src/srcset from the theme's own
// data-src "{width}" template and data-widths list (the same responsive
// image data the theme already renders, just not applied on slide change).
jQuery(function ($) {
  function loadFullImage(img) {
    if (!img || img.classList.contains('lazyloaded')) return;
    var displayWidth = Math.ceil(img.getBoundingClientRect().width) || img.width || 0;
    var dpr = window.devicePixelRatio || 1;
    var targetWidth = Math.ceil(displayWidth * dpr);
    var widths = [];
    try { widths = JSON.parse(img.dataset.widths || '[]'); } catch (e) {}
    var template = img.dataset.src || '';

    if (widths.length && template.indexOf('{width}') !== -1) {
      var chosen = widths.find(function (w) { return w >= targetWidth; }) || widths[widths.length - 1];
      var toUrl = function (w) {
        var u = template.replace('{width}', w);
        return u.indexOf('//') === 0 ? 'https:' + u : u;
      };
      img.src = toUrl(chosen);
      img.srcset = widths.map(function (w) { return toUrl(w) + ' ' + w + 'w'; }).join(', ');
      if (displayWidth) { img.sizes = displayWidth + 'px'; }
    } else if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
      if (displayWidth) { img.sizes = displayWidth + 'px'; }
      if (img.dataset.src) { img.src = img.dataset.src; }
    } else if (img.dataset.src) {
      img.src = img.dataset.src;
    } else {
      return;
    }

    img.classList.remove('lazyload');
    img.classList.add('lazyloaded');
  }

  $('.primgSlider').on('afterChange', function () {
    $('.primgSlider .slick-current img.lazyload').each(function () {
      loadFullImage(this);
    });
  });
});
